import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=191f2350&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=191f2350&prod&lang=scss&scoped=true"
import style1 from "./PasswordResetForm.vue?vue&type=style&index=1&id=191f2350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191f2350",
  null
  
)

export default component.exports